import { Group } from '@calendly/ui/components/menu'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { loadMoreData } from 'actions/home_bar/scope_dropdown'
import { encodeScopeValue } from 'components/home_bar/scope_dropdown/scope_values'
import {
  filterTermSelector,
  hasMoreTeamsSelector,
  isFilteringSelector,
  teamsSelector
} from 'selectors/home_bar'

import AllScope from './all_scope'
import Header from './header'
import Item from './item'
import ShowMore from './show_more'

const shouldShowAllScope = (isFiltering, isMeetings, isAdminOrOwner) => {
  if (isFiltering) return false
  if (isMeetings) return isAdminOrOwner
  return true
}

const TeamsList = ({ canCreateTeam, isAdminOrOwner }) => {
  const dispatch = useDispatch()
  const isFiltering = useSelector(isFilteringSelector)
  const filterTerm = useSelector(filterTermSelector)
  const teams = useSelector(teamsSelector)
  const hasMoreTeams = useSelector(hasMoreTeamsSelector)
  const isMeetings = useRouteMatch('/app/meetings')
  const showHeader = !isFiltering || teams.length > 0
  const showAllScope = shouldShowAllScope(isFiltering, isMeetings, isAdminOrOwner)

  return (
    <Group data-component="scope-dropdown-team-list">
      {showHeader && (
        <Header
          scope="team"
          showNewLink={canCreateTeam}
        />
      )}
      {showAllScope && (
        <AllScope scope="all_teams" />
      )}
      {teams.map(({ id, name, ...item }) => (
        <Item
          key={id}
          value={encodeScopeValue('page_single', id)}
          avatarLetter={item.avatar_letter}
          avatarUrl={item.avatar_url}
          filterTerm={filterTerm}
        >
          {name}
        </Item>
      ))}
      {hasMoreTeams && <ShowMore onClick={() => dispatch(loadMoreData('pages'))} />}
    </Group>
  )
}

export default TeamsList
